import React from "react";
import { Button } from "web/react/emo/button";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./skip-navigation-button.css";

export function SkipNavigationButton(): React.ReactElement {
    const onClick = (): void => {
        analytics.event({
            category: "accessibility",
            action: "click",
            label: "skip_navigation_button",
        });
    };

    const onKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>): void => {
        if (["Space", "Enter"].includes(event.key)) {
            onClick();
        }
    };
    return (
        <Button
            className={styles.skipNavButton}
            variant="secondary"
            width="full"
            href="#main"
            onClick={onClick}
            onKeyDown={onKeyDown}
            title={gettext("general.skip_to_main_content.label")}
        />
    );
}
